<template>
  <v-app full-height>
    <div
        id="envtag"
        v-if="ENVIRONMENT != 'production'"
    >
      <v-card
          width="300"
          :color="envColor"
          theme="dark"
      >
        <v-card-title class="text-label-large text-yellow text-center text-uppercase py-8 px-8 font-weight-bold">
          <!-- <v-icon color="yellow" class="mr-2">mdi-alert-outline</v-icon>  -->
          <v-icon
              color="yellow"
              class="mr-1 mb-1"
              size="small"
          >mdi-alert</v-icon>
          {{ envTitle }}
          <span
              v-if="ENVIRONMENT != 'production'"
              class="mr-2"
          >
            <!-- -  {{ mobile }} -->
            - {{ displayName }}
          </span>
        </v-card-title>
      </v-card>
    </div>
    <v-app-bar
        :color="color"
        app
    >
      <template v-if="runtimeStore.session.user">
        <v-app-bar-nav-icon
            class="hidden-lg-and-up"
            @click="drawer.visible = !drawer.visible"
        ></v-app-bar-nav-icon>
        <v-toolbar-title
            class="ml-2 pl-lg-4 d-flex"
            @click="toggleUsage"
            style="user-select: none;"
        >
          <v-icon
              v-if="route.meta.icon && mdAndDown"
              size="small"
              class="mr-1 mb-1"
          >mdi-{{ route.meta.icon
          }}</v-icon>
          <img
              v-else
              :src="PNGPIcon"
              height="20em"
              class="mr-3 mb-n1"
          ></img>
          <!-- <v-icon v-if="lgAndUp" :icon="PNGPIcon" ></v-icon> -->
          <span v-if="lgAndUp">Picker</span>
           &nbsp;<span v-if="!showUsage">{{ toolbarTitle }}</span>
          <template v-if="showUsage">
            <v-icon
                v-if="systemStore.pressureSupported"
                size="x-small"
                :color="pressureOwnContributionEstimateColor"
            >mdi-circle</v-icon> &nbsp;
            <span v-if="systemStore.memorySample">
              {{ systemStore.BytesValueToHR(systemStore.memorySample?.bytes) }} - {{ systemStore.nextMemorySampleInSeconds }}s
            </span>
          </template>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn
            icon
            v-if="deferredPrompt"
        >
          <v-icon class="pulsating">mdi-download</v-icon>

          <v-tooltip
              activator="parent"
              location="bottom"
          >Install
          </v-tooltip>

          <v-dialog
              v-model="installDialog"
              activator="parent"
              width="auto"
              scrim="black"
          >
            <v-card theme="dark">
              <v-img
                  cover
                  height="200"
                  :src="InstallImage"
              ></v-img>
              <v-card-item>
                <v-card-title>Installazione</v-card-title>
                <v-card-subtitle>
                  <span class="me-1">Stai per installare l'applicazione</span>
                  <v-icon
                      icon="mdi-download"
                      size="small"
                  ></v-icon>
                </v-card-subtitle>

              </v-card-item>
              <v-card-text>
                <p class="mb-2">
                  <v-card
                      class="mt-3 mb-5 mx-auto"
                      width="50"
                  >
                    <v-img
                        height="50"
                        :src="Logo"
                    ></v-img>
                  </v-card>
                  L'installazione ti permetterà di utilizzare l'applicazione, <br>anche quando non sei connesso ad
                  internet.<br>
                </p>
                <p class="mb-2">
                  Leggi la documentazione per informazioni sull'utilizzo.<br>
                </p>
              </v-card-text>
              <v-card-actions class="flex-column">
                <v-btn
                    size="large"
                    variant="outlined"
                    color="white"
                    @click="installDialog = false"
                >
                  <v-icon class="mr-2">mdi-close</v-icon>
                  Ignora</v-btn>
                <v-btn
                    size="large"
                    variant="elevated"
                    color="blue-darken-3"
                    id="install"
                    @click="doInstall"
                    class="mx-0 my-3"
                >Installa</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-btn>
        <v-btn
            v-if="transferStore.activeDuration > 999"
            to="/data/"
            icon
            active-class="disable-active"
        >
          <v-icon class="pulsating">mdi-transfer-up</v-icon>
          <v-tooltip
              activator="parent"
              location="bottom"
              model="tooltipTransfer"
          >Trasferimento attivo
          </v-tooltip>
        </v-btn>
        <v-btn
            v-if="!networkStore.online"
            class="disabled mr-4"
            color="red"
            icon
        >
          <v-icon outlined>mdi-network-off-outline</v-icon>
          <v-tooltip
              activator="parent"
              location="bottom"
          >Offline
          </v-tooltip>
        </v-btn>
      </template>
      <template v-else>
        <v-toolbar-title>
          <v-icon
              v-if="route.meta.icon && mdAndDown"
              size="small"
              class="mr-2"
          >mdi-{{ route.meta.icon }}</v-icon>
          {{ toolbarTitle }} </v-toolbar-title>
        <v-spacer></v-spacer>
      </template>
    </v-app-bar>

    <v-theme-provider theme="light">
      <v-main
          id="main"
          class="bg-grey-darken-3"
      >
        <v-container
            id="main-container"
            fluid
            class="pa-0 ma-0 fill-height"
        >

          <v-navigation-drawer
              v-if="runtimeStore.session.user"
              flat
              color="grey-darken-4"
              :permanent="lgAndUp"
              app
              :temporary="mdAndDown"
              v-model="drawer.visible"
              theme="dark"
              touchless
          >

            <main-menu />

            <template v-slot:append>
              <div
                  :class="`bg-grey-darken-3  py-1 px-4`"
                  v-if="ENVIRONMENT !== 'production'"
              >
                <p class="pl-2 mb-1 mx-3 text-lime">
                  <v-icon
                      size="x-small"
                      class="mb-1"
                  >mdi-circle-opacity</v-icon>
                  {{ ENVIRONMENT }}
                </p>
              </div>
              <v-btn-group
                class="d-flex"
                tiled
              >
                <v-btn 
                  to="/news"
                  icon="mdi-newspaper" 
                  class="w-33"
                  active-color="grey-darken-4"
                  ></v-btn>
                <v-btn 
                  to="/manual"
                  icon="mdi-book" 
                  class="w-33"
                  active-color="grey-darken-4"
                  ></v-btn>
                <v-btn 
                  to="/system"
                  icon="mdi-gauge" 
                  class="w-33"
                  active-color="grey-darken-4"
                  ></v-btn>
              </v-btn-group>
              <div
                  class="px-2 py-4"
                  id="whatwhenwhere"
              >
                <!-- <router-link
                    id="info-link"
                    class="ml-5 d-block"
                    to="/system/"
                ><v-icon size="x-small"> mdi-gauge</v-icon> Sistema
                </router-link> -->
                <router-link
                    id="info-link"
                    class="ml-1 d-block"
                    to="/info/"
                >
                  <span class="pl-1 mb-1 mx-3 font-weight-bold">
                    Picker
                  </span><br>
                  <p
                      class="pl-2 mx-5 my-0 py-0"
                      :title="VERSION"
                      show
                  >
                    <v-icon size="x-small" >mdi-at</v-icon> {{ npmlist.version }} ( {{ VERSION }} )
                  </p>
                  <p
                      class="pl-2 ms-5 my-0 py-0"
                      show
                  >
                    <v-icon size="x-small">mdi-clock-outline</v-icon> {{ bt_ita_date }}
                    <span
                        v-if="runtimeStore.session.user?.username == 'marco'"
                        class="font-weight-bold text-yellow"
                    >
                      {{ bt_ita_time }}
                    </span>
                  </p>
                  <p class="pl-2 mx-5 my-0 py-0">
                    <v-icon
                        size="x-small"
                        class="mb-1"
                    >mdi-account</v-icon>
                    {{ runtimeStore.session.user?.first_name }}
                    <br>
                  </p>


                </router-link>

              </div>
            </template>
          </v-navigation-drawer>

          <router-view />

        </v-container>

        <reload-prompt />

        <div
            id="toasts"
            class=""
        >
          <!-- <v-card v-for="toast in toastsStore.toasts" :key="toast" :style="`border-left: 10px solid red; min-width: 20em;`">
            <v-card-title class="text-title-large">{{ toast.title }}</v-card-title>
            <v-card-text>{{ toast.text }}</v-card-text>
          </v-card> -->
          <template
              v-for="toastData in toastsStore.toastsBucket"
              :key="toastData.uuid"
          >
            <ToastAlert :data="toastData" />
          </template>

        </div>

        <v-dialog
            v-model="showStagingDialog"
            width="auto"
            scrim="black"
        >
          <v-card theme="dark">
            <v-card-item
                class="d-flex position-sticky bg-grey-darken-4 top-0"
                style="z-index:20001;"
            >
              <v-card-title class="text-yellow">
                {{ ENVIRONMENT.toUpperCase() }}
              </v-card-title>
              <v-card-subtitle>
                <span class="ml-1">
                  Ambiente alternativo
                </span>
              </v-card-subtitle>

            </v-card-item>
            <v-card-text>
              <p class="mb-2 text-left">
                L'applicazione sta funzionando nell'ambiente di
                <span class="text-yellow">
                  {{ ENVIRONMENT.toUpperCase() }}, <br>
                  version: {{ VERSION }} <br>
                  built on: {{ bt_ita }}
                </span>
                <!-- <v-icon icon="mdi-alert" size="small" color="yellow" class="mb-1"></v-icon>  -->
                <br>
                La fascia colorata in alto a destra ricorda che ti trovi in un ambiente alternativo.<br>
                <span class="font-weight-bold">I dati raccolti in questo ambiente, sono destinati ad un database
                  separato e temporaneo:
                  vengono resettati a intervalli regolari e senza alcuna notifica.<br>
                </span><br>
                Questa applicazione è da utilizzare limitatamente a scopi di test di nuove funzionalità,
                per la verifica di nuovi servizi e per la sperimentazione.<br>
                <span class="font-weight-bold">Per raccogliere dati definitivi, esci da questa applicazione e apri
                  quella
                  corretta.</span><br>

                Leggi la documentazione per informazioni sull'utilizzo.
              </p>
            </v-card-text>
            <v-card-actions
                class="d-flex flex-column align-center position-sticky bg-grey-darken-4 bottom-0"
                style="z-index:20001;"
            >
              <v-btn
                  size="default"
                  variant="outlined"
                  color="white"
                  @click="showStagingDialog = false"
              >
                <v-icon
                    class="mr-1"
                    color="green-darken-2"
                >mdi-check</v-icon>
                Continua</v-btn>
              <v-btn
                  size="default"
                  variant="outlined"
                  color="white"
                  @click="exit"
              >
                <v-icon
                    class="mr-1"
                    color="red-darken-2"
                >mdi-close</v-icon>
                Esci</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
            v-model="showTokenAlert"
            width="auto"
            scrim="black"
        >
          <v-card theme="dark">
            <v-card-item
                class="d-flex position-sticky bg-grey-darken-4 top-0"
                style="z-index:20001;"
            >
              <v-card-title class="text-yellow">
                Autenticazione
              </v-card-title>
              <v-card-subtitle>
                <span class="ml-1">
                  Token non riconosciuto
                </span>
              </v-card-subtitle>

            </v-card-item>
            <v-card-text>
              <p class="mb-2 text-left">
                <v-icon
                    size="x-large"
                    color="error"
                    class="mb-2"
                >mdi-connection</v-icon><br>
                L'autenticazione non è valida (probabilmente è scaduta).<br>
                Dopo 60 giorni di inutilizzo dell'applicazione, l'autenticazione viene invalidata per motivi di sicurezza.<br>
                <strong>
                  Per poter riprestinare la comunicazione col server è necessario andare alla sezione "account" ed eseguire la disconnessione.
                  A questo punto è possibile autenticarsi nuovamente (necessaria connessione dati).
                </strong><br>
              </p>
            </v-card-text>
            <v-card-actions
                class="d-flex flex-column justify-center align-center position-sticky bg-grey-darken-4 bottom-0"
                style="z-index:20001;"
            >
              <v-btn
                  variant="flat"
                  color="primary"
                  to="/account"
                  @click="showTokenAlert = false"
              >vai alla sezione "account"</v-btn>
              <v-btn
                  size="default"
                  variant="flat"
                  color="error"
                  class="my-5"
                  @click="showTokenAlert = false"
              >
                continua </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


      </v-main>
    </v-theme-provider>

  </v-app>
</template>

<script setup>
import { useRoute } from 'vue-router';
import MainMenu from "@/components/MainMenu";
import ReloadPrompt from "@/components/pwa/ReloadPrompt";

import npmlist from '@/assets/json/npm.list.json'


import PNGPIcon from '@/assets/img/pngp.svg'

import ToastAlert from "@/components/ToastAlert";

import InstallImage from "@/assets/img/install.jpg";
import Logo from "/img/icons/icon.png";
// import Logo from "@/assets/img/logo.png";
import { ref, computed, onMounted, nextTick } from "vue";
import { useDisplay } from "vuetify";

import { useNetworkStore } from "@/store/network";
const networkStore = useNetworkStore();

import { useRuntimeStore } from "@/store/runtime"
const runtimeStore = useRuntimeStore();

import { useToastsStore } from "@/store/toasts";
const toastsStore = useToastsStore();

import { useTransferStore } from "@/store/transfer"
const transferStore = useTransferStore()

import { useSound } from "@/service/sound"
const soundService = useSound()

import { useApi } from "@/service/api";
const api = useApi()

import { useSystemStore } from "@/store/system";
const systemStore = useSystemStore();

// import { usePacksStore } from "@/store/media";
// const packsStore = usePacksStore();

const route = useRoute()

let toolbarTitle = computed(() => {
  return route?.meta?.title
})


const exit = () => {
  window.close()
}


const drawer = ref({
  visible: null,
});

const showTokenAlert = ref(false);
const showUsage = ref(false);
const toggleUsage = () => {
  showUsage.value = !showUsage.value
}
// const showTokenAlert = true;


let date = new Date(BUILD_TIMESTAMP);



// let envIcon = ""
let envTitle = ""
let envColor = "grey-darken-5"

// let hostname = location.hostname;
let color = 'green-darken-4';

if (ENVIRONMENT === 'staging') {
  envColor = 'blue-darken-4'
  // envIcon = "mdi-alpha-s-circle-outline"
  envTitle = "staging"
}
if (ENVIRONMENT === 'development') {
  envColor = "red-darken-4"
  // envIcon = "mdi-alpha-d-circle-outline"
  envTitle = "development"
}


// const deployed_at_string_arr = date.toLocaleString('it-IT', { timeZone: 'Europe/Rome' }).split(",")
// const deployed_at_string_date = deployed_at_string_arr[0].trim()
// const deployed_at_string_time = deployed_at_string_arr[1].trim()
// const deployed_at_string_time_hh_mm = deployed_at_string_time.split(":").slice(0, 2).join(":")

const dtls = date.toLocaleString('it-IT', { timeZone: 'Europe/Rome' }).split(",")
const bt_ita = new Date(BUILD_TIMESTAMP).toLocaleString('it-IT', { timeZone: 'Europe/Rome' })

const bt_ita_date = dtls[0].trim()
const bt_ita_time = dtls[1].trim()


// const deployed_at_string_arr = date.toLocaleString('it-IT', { timeZone: 'Europe/Rome' }).split(",")
// const deployed_at_string_date = "aaa"
// const deployed_at_string_time = "bbb"
// const deployed_at_string_time_hh_mm = "ccc"




const { mobile, lgAndUp, mdAndDown } = useDisplay();
const display = useDisplay();
// console.log(display)

onMounted(() => {
  nextTick(setAppWrapperHeight);
  if (ENVIRONMENT !== 'development') {
    soundService.play("startup")
  }

  checkToken()

})

const displayName = computed(() => {
  if (!display?.name) return "not set yet"
  return display.name.value.replaceAll("\"", "")
})

// Initialize deferredPrompt for use later to show browser install prompt.
const installDialog = ref(false);

const showStagingDialog = ref(ENVIRONMENT !== 'production' && ENVIRONMENT !== 'development')


let deferredPrompt = ref(null);

window.addEventListener('beforeinstallprompt', (e) => {
  deferredPrompt.value = e;
  console.log('beforeinstallprompt Event fired');
  console.log(deferredPrompt.value);
  installDialog.value = true;
});

const doInstall = async () => {
  if (deferredPrompt.value !== null) {
    deferredPrompt.value.prompt();
    const { outcome } = await deferredPrompt.value.userChoice;
    if (outcome === 'accepted') {
      deferredPrompt.value = null;
    }
  }
};






const repairHeight = () => {
  // I hate this freaking hack
  const document_h_px = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  const applicationWrapperElement = document.querySelector(".v-application__wrap")
  applicationWrapperElement.style.height = document_h_px + "px"
  const awrapper_h_px = applicationWrapperElement.clientHeight

  if (awrapper_h_px == document_h_px) {
    console.log("📱 heights (document, app_wrapper) are equal", document_h_px, awrapper_h_px)
  }

  if (awrapper_h_px > document_h_px) {
    console.log("📱 awrapper_h_px > document_h_px", awrapper_h_px, document_h_px)
    applicationWrapperElement.style.height = document_h_px + "px!important"
    applicationWrapperElement.style.minHeight = "0"
    applicationWrapperElement.style.maxHeight = document_h_px + "px!important"
    console.log("📱 height repaired")

  }

  if (awrapper_h_px < document_h_px) {
    console.log("📱 awrapper_h_px > document_h_px", awrapper_h_px, document_h_px)
    console.log("📱 not expected")
  }

}

const setAppWrapperHeight = () => {
  console.log("📱 setAppWrapperHeight")
  repairHeight()
  return
}


const checkToken = async () => {
  if (networkStore.online) {
    const result = await api.tracker.sdtg()
    if (result?.response) {
      if (result?.response?.status >= 200 && result?.response?.status < 300) {
      }
      if (result?.response?.status >= 400 && result?.response?.status < 500) {
        showTokenAlert.value = true
      }
    }
  }
}


const pressureOwnContributionEstimateColor = computed(() => {
  if (systemStore.lastRecordPressure?.ownContributionEstimate < .25) {
    return "gray-darken-2";
  } else if (systemStore.lastRecordPressure?.ownContributionEstimate < .50) {
    return "success";
  } else if (systemStore.lastRecordPressure?.ownContributionEstimate < .75) {
    return "warning";
  } else {
    return "error";
  }
})


</script>




<style scoped>
#main {
  position: relative;
}

#main>* {
  /* zoom: 1.4; */
}

#main-container {
  align-items: start;

}

#main-container>.v-card {}


#info-link {
  color: #fff;
  text-decoration: none;
}

#whatwhenwhere {
  /*border-top: 1px solid grey; */
}

#envtag {
  pointer-events: none;

  position: fixed;
  top: -2em;
  right: 0;
  height: 300px;
  width: 300px;
  z-index: 100000;
  /* transform: translate(25%,25%) rotate(45deg); */
}

#envtag .v-card {
  margin: 0 !important;
  opacity: 0.8;
  /* transform-origin: 50% 50%; */
  transform: translate(25%, 75%) rotate(45deg);
}


.v-toolbar-title {
  flex-grow: 10;
}

.pulsating {
  animation-name: color;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
}


@keyframes color {
  from {
    color: orange;
  }

  to {
    color: white;
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px orange;
  }
}


#toasts {
  position: fixed;
  padding: 2em 1em 1em 1em;
  top: 0;
  right: 0;
  z-index: 100000;
  /* height: 100%; */
  /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.5) 20%, rgba(0,0,0,.5) 80%, rgba(0,0,0,0) 100%); */
  transition: all 0.2s ease;
}
</style>
